import { safeParseJson } from './utils/json.js';
import type { Phase, Role, RoomState, GameSnapshot } from '../shared/types.js';

export type ControllerState = {
  currentRoomCode: string;
  currentRole: Role | null;
  currentPhase: Phase;
  currentPlayerId: string;
  reconnectToken: string;
  autoJoinPending: boolean;
  quickToastTimeout: number | null;
  lastSnapshot: GameSnapshot | null;
  lastRoomState: RoomState | null;
};

export const state: ControllerState = {
  currentRoomCode: '',
  currentRole: null,
  currentPhase: 'lobby',
  currentPlayerId: '',
  reconnectToken: '',
  autoJoinPending: false,
  quickToastTimeout: null,
  lastSnapshot: null,
  lastRoomState: null
};

type StoredSession = {
  code: string;
  name: string;
  playerId: string;
  reconnectToken: string;
};

const STORAGE_KEY = 'abyss-link-controller-session';

export const loadStoredSession = (): StoredSession | null => {
  const raw = window.localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;

  const parsed = safeParseJson<StoredSession>(raw);
  if (!parsed || !parsed.code || !parsed.name || !parsed.playerId || !parsed.reconnectToken) return null;

  return parsed;
};

export const persistSession = (name: string): void => {
  if (!state.currentRoomCode || !state.reconnectToken || !state.currentPlayerId || !name.trim()) return;

  const session: StoredSession = {
    code: state.currentRoomCode,
    name,
    playerId: state.currentPlayerId,
    reconnectToken: state.reconnectToken
  };

  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
};

export const clearStoredSession = (): void => {
  window.localStorage.removeItem(STORAGE_KEY);
};

export const clearStoredSessionToken = (): void => {
  state.currentPlayerId = '';
  state.reconnectToken = '';
  state.autoJoinPending = false;
  clearStoredSession();
};
